import { Routes, Route, Navigate } from "react-router";
import { SHARED_ROUTES } from "definitions/constants/routeConstants";
import allRoutes from "definitions/routes";
import useCaminoStore from "stores/caminoStore";
import { useEffect } from "react";
import apiClient from "services/ApiClient";
import RequestInterceptor from "services/ApiClient/requestInterceptor";
import { getAnalytics } from "services/analytics";
import { useFeatureContext } from "contexts/FeatureContext";

export default function AllRoutes() {
  const token = document.querySelector("[name=csrf-token]")?.getAttribute("content");

  const fetchUserBundle = useCaminoStore((state) => state.fetchUserBundle);
  const user = useCaminoStore((state) => state.currentUser);
  const { isEnabled } = useFeatureContext();

  useEffect(() => {
    apiClient.interceptors = [
      new RequestInterceptor((url, opts) => {
        const headers = opts.headers || {};
        if (token) {
          headers["X-CSRF-Token"] = token;
        }
        return { url, options: { ...opts, headers } };
      }),
    ];
  }, [token]);

  useEffect(() => {
    // Fetch the user bundle which includes user data and feature flags
    fetchUserBundle();
  }, [fetchUserBundle]);

  useEffect(() => {
    const analytics = getAnalytics();
    // Identify user for analytics
    if (user?.id) {
      analytics.identify(user.id, {
        email: user.workEmail || user.personalEmail,
        name: user.fullName,
        company_id: user.companyId,
        permission: user.permission,
      });
    } else {
      analytics.reset();
    }
  }, [user]);

  // Routes gated by a feature flag are skipped when the flag is off, so a
  // direct URL hit falls through to the catch-all redirect.
  const visibleRoutes = allRoutes.filter(({ featureFlag }) => !featureFlag || isEnabled(featureFlag));

  return (
    <Routes>
      {visibleRoutes.map(({ path, component }) => (
        <Route key={path} path={path} element={component} />
      ))}
      <Route key="undefined-route" path="*" element={<Navigate to={SHARED_ROUTES.home} replace />} />
    </Routes>
  );
}
